<template>
  <!--
        作者：luo
        时间：2020-10-29
        描述：插件中心-首页弹窗
    -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="100px">
      <el-form-item label="开启首页弹窗" prop="is_open"><el-switch v-model="form.is_open"></el-switch></el-form-item>
      <el-form-item label="弹窗名称" :rules="[{ required: true, message: ' ' }]" prop="name">
        <el-input class="max-w460" v-model="form.name" placeholder="" type="text"></el-input>
        <div class="gray">建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗</div>
      </el-form-item>
      <div v-if="form.is_open">
        <el-form-item label="类型">
          <el-radio v-model="form.type" :label="1" >代理商列表</el-radio>
        </el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>

  </div>
</template>
<script>
  import HomepopupApi from '@/api/homepopup.js';
  export default {
    components: {
      // Upload,
      // Setlink,
      // GetCoupon
    },
    data() {
      return {
        form: {
          is_open: false,
          name: '',
          title: '',

        },
        // coupon: [],
        /*是否加载完成*/
        loading: false,
        /*添加优惠券*/
        open_add: false,
        /*是否上传图片*/
        isupload: false,
        /*是否选择链接*/
        is_linkset: false
      };
    },
    created() {
      this.getData();
    },
    methods: {


      /*获取数据*/
      getData() {
        let self = this;
        HomepopupApi.getData()
          .then(data => {
            self.form = data.data.vars.values;
            if (self.form.is_open == 'true') {
              self.form.is_open = true;
            }
            if (!self.form.hasOwnProperty('coupon')) {
              self.coupon = [];
            } else {
              self.coupon = self.form.coupon;
            }
          })
          .catch(error => {});
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = self.form;
        console.log(params);
        if (self.form.type == 3) {
          params.coupon = self.coupon;
        }
        // if (params.is_open && !self.checkData(params)) {
        //   return false;
        // }
        self.loading = true;
        HomepopupApi.saveData(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getData();
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*选择链接*/
      changeLink() {
        this.is_linkset = true;
      },

      /*获取链接并关闭弹窗*/
      closeLinkset(e) {
        this.is_linkset = false
        if (e){
          this.form.link = e.url
        }
      },


    }
  };
</script>

<style>
  .reward-list .reward-item {
    margin-bottom: 10px;
    padding: 10px 20px;
    border: 1px solid #ebeef5;
  }

  .reward-list .delete-reward {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/homepopup/index.vue